import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'
import FiltersBooleanBody from './filtersBooleanBody'

const FiltersProMusic = ({ location, history, isAtBottom, count }) => {
  const parsedLocation = parseLocation(location)
  const isChecked = parsedLocation.include_pro_affiliated !== 'false'

  const onChange = (event) => {
    const checkedValue = event.target.checked
    let newQuery = Object.assign({}, parsedLocation)
    delete newQuery.page

    newQuery.include_pro_affiliated = !!checkedValue

    history.push(makeLink(newQuery))
  }

  return (
    <FiltersBooleanBody
      name='include_pro_affiliated'
      label='Include P.R.O. Music'
      onChange={onChange}
      isChecked={isChecked}
      isAtBottom={isAtBottom}
      count={count}
      icon='performing-rights-organizations' />
  )
}

FiltersProMusic.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isAtBottom: PropTypes.bool,
  count: PropTypes.number
}

export const FiltersProMusicComponent = FiltersProMusic
export default withRouter(FiltersProMusic)



// WEBPACK FOOTER //
// ./client/components/filters/filtersProMusic.js